(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }
  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pibelli-statistics-image"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pibelli-statistics')) {
  customElements.define('pibelli-statistics', class extends HTMLElement {
    connectedCallback() {
      this.frames = new Set();
      const cards = [...this.querySelectorAll('.pibelli-stats__card')];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.animate !== 'true' || reduced || !('IntersectionObserver' in window)) return;
      const duration = Number(this.dataset.duration) || 1200;
      const targets = new Map();
      cards.forEach(card => {
        const count = card.querySelector('.pibelli-stats__count');
        const raw = count.dataset.value.trim();
        if (!/^-?\d+(?:\.\d+)?$/.test(raw)) return;
        const decimals = (raw.split('.')[1] || '').length;
        targets.set(card, {count, raw, value:Number(raw), decimals});
        count.textContent = (0).toFixed(decimals);
      });
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(e => e.isIntersecting);
        visible.forEach((entry, index) => {
          const card = entry.target;
          this.observer.unobserve(card);
          const target = targets.get(card);
          if (!target) return;
          card.classList.add('is-counting');
          const start = performance.now() + index * 80;
          const tick = now => {
            if (!this.isConnected) return;
            const progress = Math.min(1, Math.max(0, (now - start) / duration));
            const eased = 1 - Math.pow(1 - progress, 3);
            target.count.textContent = progress === 1 ? target.raw : (target.value * eased).toFixed(target.decimals);
            if (progress < 1) schedule();
            else card.classList.remove('is-counting');
          };
          const schedule = () => {
            const id = requestAnimationFrame(now => { this.frames.delete(id); tick(now); });
            this.frames.add(id);
          };
          schedule();
        });
      }, {threshold:0.25});
      targets.forEach((_, card) => this.observer.observe(card));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.frames?.forEach(id => cancelAnimationFrame(id));
      this.querySelectorAll('.pibelli-stats__count').forEach(count => { count.textContent = count.dataset.value; });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
